import {client} from '../helpers/api';

export async function postVerifyCode({email, code}) {
  const body = {email_id: email, token: code};

  const response = await client.post('/api/verify-code', body);

  if (response.data?.status) {
    return response.data?.message || 'Success';
  } else if (response.data?.status === false) {
    throw response.data?.message || '';
  }
  throw response;
}
